export default "__VITE_PUBLIC_ASSET__2d94b340__"